import { ref } from 'vue';
import { LocalStorage } from 'shared/helpers/localStorage';

const STORAGE_KEY = 'recentEmojis';
const MAX_RECENT_EMOJIS = 30;

// Shared across every picker on the page, so a pick in one shows up in the others.
const recentEmojis = ref(LocalStorage.get(STORAGE_KEY) || []);

export const useRecentEmojis = () => {
  const addRecentEmoji = emoji => {
    recentEmojis.value = [
      emoji,
      ...recentEmojis.value.filter(item => item !== emoji),
    ].slice(0, MAX_RECENT_EMOJIS);
    try {
      LocalStorage.set(STORAGE_KEY, recentEmojis.value);
    } catch {
      // Storage can be blocked (e.g. the widget inside a sandboxed iframe); keep it in memory.
    }
  };

  return { recentEmojis, addRecentEmoji };
};
